export default "__VITE_ASSET__CIJgYocu__"